export const DEFAULT_API_REQUEST_TIMEOUT_MS = 60000;
